import { jsx as _jsx } from "react/jsx-runtime";
// Components
import { RoutePointBase, RoutePointOrder, } from "../RouteForm2/createRoutePointsTransferOptions";
export const RouteBuilderItem = ({ item, bases, orders, onCancelOrder, }) => {
    const isBase = Boolean(item.idBase);
    const isOrder = Boolean(item.idOrder);
    const base = bases.find((b) => b.id === item.idBase);
    const order = orders.find((o) => o.id === item.idOrder);
    let content = null;
    if (isBase)
        content = _jsx(RoutePointBase, { point: item, base: base });
    if (isOrder)
        content = (_jsx(RoutePointOrder, { point: item, order: order, onCancelOrder: item.idOrder && onCancelOrder && !item.isDeleted &&
                item.orderStatus !== "CANCELLED" &&
                item.orderStatus !== "DISPATCHER_CANCELLED"
                ? () => onCancelOrder(item.idOrder)
                : undefined }));
    return content;
};
export default RouteBuilderItem;
